"use client"

import { MoveUpLeft } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MoveUpLeftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MoveUpLeftIcon = component(Icon)({ as: MoveUpLeft })
